module.exports = __webpack_public_path__ + "img/19_45.db4abd4f.png";